<template>
    <div>
        <app-sub-title text="PQR's" />
        <button class="btn btn-primary" @click="startCreatePetition()">
            <i class="fa fa-wpforms"></i> Crear nueva petición
        </button>
        <div class="filters">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="d-flex1 justify-content-around1">
                            <b-row>
                                <b-col cols="12" md="4" lg="2">
                                    <app-form-select-input
                                        :options="petitionTypes"
                                        placeholder="Tipo petición"
                                        v-model="filters.typeId"
                                    />
                                </b-col>
                                <b-col cols="12" md="4" lg="3">
                                    <app-form-select-input
                                        :options="petitionStatuses"
                                        placeholder="Estado de la petición"
                                        v-model="filters.statusPetition"
                                    />
                                </b-col>
                                <b-col cols="12" md="4" lg="2">
                                    <app-form-text-input
                                        placeholder="usuario creador"
                                        v-model="filters.nameUser"
                                    >
                                    </app-form-text-input>
                                </b-col>
                                <b-col cols="12" md="4" lg="2">
                                    <app-form-select-input
                                        placeholder="Categoria"
                                        :options="categories"
                                        v-model="filters.category"
                                        @change="onSelectCategory"
                                    >
                                    </app-form-select-input>
                                </b-col>
                                <b-col cols="12" lg="2">
                                    <app-form-select-input
                                        placeholder="SubCategoria"
                                        :options="subCategories"
                                        v-model="filters.subCategory"
                                    >
                                    </app-form-select-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="2">
                                    <label for="from">Desde</label>
                                    <b-form-input
                                        id="from"
                                        placeholder="Desde"
                                        type="date"
                                        v-model="filters.from"
                                /></b-col>
                                <b-col cols="12" md="2">
                                    <label for="to">Hasta</label>
                                    <b-form-input
                                        id="to"
                                        placeholder="Hasta"
                                        type="date"
                                        v-model="filters.to"
                                /></b-col>
                            </b-row>
                            <div
                                class="d-flex justify-content-end align-items-end buttons-cell"
                            >
                                <button
                                    @click="applyFilters()"
                                    class="btn btn-primary flex-grow-0 flex-shrink-0"
                                >
                                    <i class="fa fa-filter"></i> Filtrar
                                </button>
                                <button
                                    @click="cancelFilter"
                                    class="btn btn-secondary flex-grow-0 flex-shrink-0"
                                >
                                    <i class="fa fa-times-circle"></i> Reiniciar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="alert alert-success" v-if="!petitions.length">
                ¡No hay datos!
            </div>
        </div>
        <div class="table-responsive" v-if="petitions.length">
            <table class="table table-sm table-hover table-bordered">
                <thead class="thead-orange">
                    <tr class="x-d-flex">
                        <th>Tipo petición</th>
                        <th>Usuario</th>
                        <th>Descripción</th>
                        <th>Fecha creación</th>
                        <th>Fecha vencimiento</th>
                        <th>Estado</th>
                        <th>solución</th>
                        <th>Archivos</th>
                        <th colspan="1"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="petition in petitions"
                        class="x-d-flex"
                        :key="petition.id"
                        :class="petitionColorStatus(petition)"
                    >
                        <td>{{ petition.petition_type.name }}</td>
                        <td>{{ petition.user.name }}</td>
                        <td>{{ petition.description | elipsis(80) }}</td>
                        <td>{{ petition.created_at | datetime }}</td>
                        <td>{{ petition.due_date | datetime }}</td>
                        <td>
                            {{
                                !!petition.petition_status
                                    ? petition.petition_status.name
                                    : ''
                            }}
                        </td>
                        <td>
                            {{
                                !!petition.resolution ? petition.resolution : ''
                            }}
                        </td>
                        <td>
                            <div v-if="petition.files.length">
                                <div
                                    v-for="(file, i) in petition.files"
                                    :key="i"
                                >
                                    <a
                                        v-if="
                                            file.resolution ||
                                            file.user_id == user.id
                                        "
                                        :href="'/download/' + file.id"
                                        target="_blank"
                                        >{{ i + 1 }} - {{ file.name }}</a
                                    >
                                </div>
                            </div>
                        </td>
                        <td>
                            <b-btn
                                size="sm"
                                variant="primary"
                                title="Ver PQR"
                                @click="seeMore(petition)"
                            >
                                <i
                                    class="fa fa-search-plus"
                                    aria-hidden="true"
                                ></i>
                            </b-btn>
                            <b-btn
                                size="sm"
                                v-if="
                                    !petition.approved_by_client &&
                                    petition.approved_by_company
                                "
                                variant="primary"
                                title="Aprobar Respuesta"
                                @click="startApprove(petition)"
                            >
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </b-btn>
                            <b-btn
                                size="sm"
                                v-if="
                                    !petition.approved_by_client &&
                                    petition.approved_by_company
                                "
                                class="btn btn-danger"
                                title="Rechazar Respuesta"
                                @click="startRejectPetition(petition)"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </b-btn>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            class="d-flex flex-column align-items-center"
            v-if="petitions.length"
        >
            <app-paginator
                :current-page="data.current_page"
                :last-page="data.last_page"
                :from="data.from"
                :to="data.to"
                :per-page="data.per_page"
                :total="data.total"
                :onChangePage="onChangePage"
            />
        </div>

        <app-pop-up
            title="Formulario de petición"
            id="petition-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <app-pqr-form :on-save="onSave"></app-pqr-form>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('petition-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up id="view-petition-more" title="Petición">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                        <h5>Fecha de creación</h5>
                        <label>{{ petitionView.date | datetime }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tipo de petición</h5>
                        <label>{{ petitionView.type }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Cliente</h5>
                        <label>{{ petitionView.client }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuario</h5>
                        <label>{{ petitionView.user }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Estado</h5>
                        <label>{{ petitionView.status }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tiempo de respuesta</h5>
                        <label>{{ petitionView.resolveTime }} días</label>
                    </div>
                </div>
                <b-tabs content-class="mt-3">
                    <b-tab title="Descripcion" active>
                        <h5 style="text-align: center">
                            <label for="anotation">Descripción</label>
                        </h5>
                        <textarea
                            type="text"
                            id="anotation"
                            class="form-control"
                            disabled="true"
                            cols="80"
                            rows="8"
                            v-model="petitionView.description"
                        ></textarea>
                        <div v-if="!!petitionView.resolution">
                            <h5 style="text-align: center">
                                <label for="anotation">Solución</label>
                            </h5>
                            <textarea
                                type="text"
                                id="anotation"
                                class="form-control"
                                disabled="true"
                                cols="80"
                                rows="8"
                                v-model="petitionView.resolution"
                            ></textarea>
                        </div>
                    </b-tab>
                    <b-tab title="Comentarios" active>
                        <b-table
                            v-if="comments.length"
                            striped
                            :fields="commentsFields"
                            :items="comments"
                        >
                            <template slot="created_at" slot-scope="{ item }">
                                <small>{{ item.created_at | datetime }}</small>
                            </template>
                            <template slot="user" slot-scope="{ item }">
                                {{ item.user.name }}
                            </template>
                        </b-table>
                        <span v-else>No hay comentarios </span>
                    </b-tab>
                </b-tabs>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Aprobación de petición"
            id="approve-petition-client"
            :onClose="cleanPetitionSelected"
        >
            <div class="body" slot="body">
                <h5>¿Cómo califica la gestión de la PQR?</h5>
                <small
                    >Seleccione la opción que represente su estado de
                    satisfacción.</small
                >
                <div class="mt-3">
                    <b-row v-for="option in satisfactionScale" :key="option.id">
                        <b-col
                            ><b-form-radio
                                class=""
                                name="satisfaction"
                                v-model="satisfaction"
                                :value="option.id"
                                >{{ option.name }}</b-form-radio
                            ></b-col
                        >
                    </b-row>
                </div>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="approve(petitionSelect)"
                >
                    Calificar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Rechazo de petición"
            id="reject-petition-client"
            :onClose="cleanPetitionReject"
        >
            <div class="body" slot="body">
                <h5>¿Esta seguro que desea rechazar esta petición?</h5>
                <label
                    >Agregue comentario justificando porque rechazo la
                    solución</label
                >
                <app-add-petition-comment
                    id="petition-comment-client"
                    :petition="petitionComment"
                    :disabled="inProgress"
                    :on-save="rejectConfirm"
                    errorMessage="Debe escribir el comentario"
                    :required="true"
                />
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" @click="reject(petitionSelect)">
                    Rechazar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Comentarios de la petición"
            id="view-comments-petition-client"
        >
            <div class="body" slot="body">
                <div class="table-responsive">
                    <table
                        class="table table-sm table-hover table-bordered table-striped"
                    >
                        <thead class="thead-orange">
                            <tr class="x-d-flex">
                                <th>Usuario</th>
                                <th>Estado de la petición</th>
                                <th>Comentario</th>
                                <th>Fecha creación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="comment in commentsPetitionSelect"
                                :key="comment.id"
                                class="x-d-flex"
                            >
                                <td>{{ comment.user.name }}</td>
                                <td>{{ comment.petition_status.name }}</td>
                                <td>{{ comment.comment }}</td>
                                <td>{{ comment.created_at | datetime }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import petitionsRepository from '../../../repositories/petitions.repository.js'
import PqrForm from './PqrForm.vue'
import PopUp from '../../UI/Controls/PopUp/PopUp.vue'
import Title from '../../UI/Layout/Title.vue'
import SubTitle from '../../UI/Layout/SubTitle.vue'
import Paginator from '../../UI/Controls/Paginator/Paginator.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue'
import AddPetitionComment from '../../ClientService/PetitionComment/AddPetitionComment.vue'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
    components: {
        appPqrForm: PqrForm,
        appPopUp: PopUp,
        appTitle: Title,
        appSubTitle: SubTitle,
        appPaginator: Paginator,
        appFormSelectInput: FormSelectInput,
        appFormTextInput: FormTextInput,
        appAddPetitionComment: AddPetitionComment,
    },

    data() {
        return {
            petitions: [],
            comments: [],
            petitionView: {
                user: '',
                client: '',
                type: '',
                date: '',
                description: '',
                status: '',
            },
            data: '',
            page: 1,
            filters: {
                typeId: '',
                nameUser: '',
                statusPetition: '',
                category: '',
                subCategory: '',
                from: '',
                to: '',
            },
            petitionSelect: {},
            petitionComment: {},
            comment: '',
            commentsPetitionSelect: [],
            categories: [],
            subCategories: [],
            satisfaction: '',
            commentsFields: [
                {
                    key: 'created_at',
                    label: 'Fecha',
                },
                {
                    key: 'user',
                    label: 'Usuario',
                },
                {
                    key: 'comment',
                    label: 'Comentario',
                },
            ],
            satisfactionScale: [
                { id: 4, name: '😍 Muy satisfecho' },
                { id: 3, name: '🙂 Satisfecho' },
                { id: 2, name: '😞 Insatisfecho' },
                { id: 1, name: '😡 Muy insatisfecho' },
            ],
        }
    },

    validations: {
        comment: { required },
    },
    computed: {
        ...mapGetters(['petitionTypes', 'petitionStatuses']),
    },
    methods: {
        petitionColorStatus(petition) {
            if (!!petition.resolved) return 'table-success'
            if (petition.petition_status.slug === 'asignado')
                return 'table-info'
        },
        loadPetitions() {
            const pr = Object.assign({}, petitionsRepository)
            pr.loadPetitionsByClient(this.client.id, this.filters, this.page)
                .then((data) => {
                    this.data = data
                    this.petitions = data.data
                })
                .catch((error) =>
                    toastr.error('Error al cargar las peticiones del cliente')
                )
        },
        startCreatePetition() {
            this.selectUser = ''
            this.$bus.$emit('petition-form.open')
        },
        onSave() {
            this.$bus.$emit('petition-form.close')
            this.loadPetitions()
        },
        onSaveComment() {
            this.$bus.$emit('petition-comment-client.close')
            this.loadPetitions()
        },
        cleanForm() {
            this.$bus.$emit('petition-form.clean')
        },
        onChangePage(page) {
            this.page = page
            this.loadPetitions()
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(
                (key) => (this.petitionView[key] = '')
            )

            this.petitionView.user = petition.user.name
            this.petitionView.client = petition.client.name
            this.petitionView.type = petition.petition_type.name
            this.petitionView.resolveTime = petition.petition_type.resolve_time
            this.petitionView.date = petition.created_at
            this.petitionView.description = petition.description
            this.petitionView.status = petition.petition_status.name
            this.petitionView.resolution = petition.resolution
            this.petitionComments(petition.id)
            this.$bus.$emit('view-petition-more.open')
        },
        startApprove(petition) {
            this.petitionSelect = petition
            this.$bus.$emit('approve-petition-client.open')
        },
        startRejectPetition(petition) {
            this.petitionSelect = petition
            this.petitionComment = petition
            this.$bus.$emit('reject-petition-client.open')
        },
        approve() {
            if (!this.satisfaction)
                return toastr.error(
                    'Debe seleccionar una opción de calificación'
                )

            const formData = new FormData()
            formData.append('userId', this.user.id)
            formData.append('satisfaction', this.satisfaction)

            const pr = Object.assign({}, petitionsRepository)
            pr.setPetitionQualification(this.petitionSelect.id, formData)
                .then((data) => {
                    const { status } = data
                    this.petitionSelect = {}
                    this.$bus.$emit('approve-petition-client.close')
                    this.loadPetitions()
                    toastr.success('Petición calificada correctamente.')
                    this.satisfaction = ''
                })
                .catch((error) => {
                    toastr.error('No fue posible aprobar la petición')
                })
        },
        reject() {
            this.$bus.$emit('petition-comment-client.save')
        },
        rejectConfirm() {
            const formData = new FormData()
            formData.append('userId', this.user.id)

            const pr = Object.assign({}, petitionsRepository)
            pr.rejectPetitionByClient(this.petitionSelect.id, formData)
                .then((data) => {
                    this.petitionSelect = {}
                    this.$bus.$emit('reject-petition-client.close')
                    this.loadPetitions()
                    toastr.success('Petición rechazada correctamente')
                    this.onSaveComment()
                })
                .catch((error) => {
                    toastr.error('No fue posible rechazar la petición')
                })
        },
        applyFilters() {
            this.page = 1
            this.loadPetitions()
        },
        cancelFilter() {
            this.page = 1
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.loadPetitions()
        },
        cleanPetitionSelected() {
            this.petitionSelect = {}
        },
        cleanPetitionReject() {
            this.petitionSelect = {}
            this.petitionComment = {}
            this.$bus.$emit('petition-comment-client.clean')
        },
        seeCommentsByPetition(petition) {
            this.commentsPetitionSelect = petition.comments
            this.$bus.$emit('view-comments-petition-client.open')
        },
        async loadPetitionCategories() {
            const { data } = await repo.get(
                'petitions/categories',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.categories = data
        },
        async onSelectCategory() {
            if (this.filters.category !== '') {
                const { data } = await repo.get(
                    'petitions/sub-categories',
                    { category: this.filters.category },
                    'Lo sentimos, ha ocurrido un error'
                )
                this.subCategories = data
                this.filters.subCategory = data[0].id
            }
        },
        async petitionComments(id) {
            const { data } = await repo.get(
                `petitions/${id}/petitionCommentsByStatus`,
                'Lo sentimos, ha ocurrido un error'
            )
            this.comments = data
        },
    },

    created() {
        this.loadPetitionCategories()
        this.loadPetitions()
        this.load('petitionTypes')
        this.load('petitionStatuses')
    },
}
</script>
